module.exports = __webpack_public_path__ + "assets/img/img-fv.05ea6e09.jpg";